module.exports = __webpack_public_path__ + "img/2-6.4e387f84.gif";